import { Injectable, inject } from '@angular/core'
import { HttpClient } from '@angular/common/http'
import { Observable } from 'rxjs'

import { environment } from '../../../../environments/environment'

export interface IncidentExport {
  id: number
  dateStart: string
  dateEnd: string
  dateCreated: string
}

export interface IncidentExportDownloadUrl {
  url: string
}

export interface IncidentExportStatus {
  enabled: boolean
}

@Injectable({ providedIn: 'root' })
export class IncidentExportService {
  private readonly http = inject(HttpClient)
  private readonly apiPath = `${environment.apiBaseUrl}/incidents`

  getStatus(): Observable<IncidentExportStatus> {
    return this.http.get<IncidentExportStatus>(`${this.apiPath}/status`)
  }

  listExports(): Observable<IncidentExport[]> {
    return this.http.get<IncidentExport[]>(`${this.apiPath}/exports`)
  }

  getDownloadUrl(exportId: number): Observable<IncidentExportDownloadUrl> {
    return this.http.get<IncidentExportDownloadUrl>(
      `${this.apiPath}/exports/${exportId}/download-url`
    )
  }
}
